import { Injectable } from '@angular/core';
import { Diagnostic } from '@ionic-native/Diagnostic';
import { Geolocation, Geoposition } from '@ionic-native/geolocation';
import { Observable, Subject } from 'rxjs';
import { TotvsNotificationProvider } from './totvs-notification-provider';
import { EmptyObservable } from "rxjs/observable/EmptyObservable";

@Injectable()
export class MapProvider {

    constructor(
        private _geolocation: Geolocation,
        private _notification: TotvsNotificationProvider,
        private diagnostic: Diagnostic) {
    }

    async getCurrentPosition(): Promise<Geoposition> {
        return this.diagnostic.isLocationAvailable().then((isLocationAvailable: boolean) => {
            if (isLocationAvailable) {
                return this._geolocation
                    .getCurrentPosition({ enableHighAccuracy: true, timeout: 30000, maximumAge: 10000 })
                    .then((geoposition: Geoposition) => {
                        return geoposition;
                    })
                    .catch(err => {
                        console.log(err);
                        return null;
                    });
            } else {
                return null;
            }
        }).catch(err => {
            console.log(err);
            return null;
        });
    }

    watchPosition(): Observable<any> {
        return new Observable((observer) => {
            this.diagnostic.isLocationAvailable()
                .then((isLocationAvailable: boolean) => {
                if (isLocationAvailable) {
                    this._geolocation
                        .watchPosition({ enableHighAccuracy: true, timeout: 30000, maximumAge: 120000 })
                        .subscribe((geoposition: Geoposition) => {
                           observer.next(geoposition);
                        }, (error: any) => {
                           console.log(error);
                           observer.error(error);
                        }
                    );
                }
                else {
                    console.log("GPS disable");
                    observer.error("GPS disable");
                }
            });
         });
    }
}
